import { useLanguage } from '../../contexts/LanguageContext'

export default function AdminAccessDenied() {
  const { t } = useLanguage()

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-night-950 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold text-gray-900 dark:text-slate-100 mb-2">
          {t('admin.accessDenied.title')}
        </h1>
        <p className="text-gray-600 dark:text-slate-300">
          {t('admin.accessDenied.message')}
        </p>
      </div>
    </div>
  )
}